import React, { useState } from 'react';
import BookLibrary from './BookLibrary/BookLibrary';
import ExplorePage from './ExplorePage';
import './App.css';

function HomePage() {
  const [activeNav, setActiveNav] = useState('home');
  const [showContactModal, setShowContactModal] = useState(false);
  const [showLibrary, setShowLibrary] = useState(false);
  const [showExplore, setShowExplore] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState('');
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleNavClick = (section) => {
    setActiveNav(section);
    setMobileMenuOpen(false);
    
    // Reset all views first
    setShowContactModal(false);
    setShowLibrary(false);
    setShowExplore(false);
    
    // Then show the appropriate view
    if (section === 'contact') {
      setShowContactModal(true);
    } else if (section === 'books') {
      setShowLibrary(true);
    } else if (section === 'explore') {
      setShowExplore(true);
    }
  };

  const handleContactChange = (e) => {
    setContactForm({ ...contactForm, [e.target.name]: e.target.value });
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('sending');
    setTimeout(() => {
      setFormStatus('success');
      setContactForm({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => {
        setShowContactModal(false);
        setFormStatus('');
      }, 2000);
    }, 1500);
  };

  const cards = [
    { id: 1, title: 'Fiction', image: 'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?w=400&h=500&fit=crop', description: 'Explore worlds of imagination', count: '2,500+ Books' },
    { id: 2, title: 'Science', image: 'https://images.unsplash.com/photo-1532012197267-da84d127e765?w=400&h=500&fit=crop', description: 'Discover knowledge and research', count: '1,800+ Books' },
    { id: 3, title: 'History', image: 'https://images.unsplash.com/photo-1461360370896-922624d12aa1?w=400&h=500&fit=crop', description: 'Learn from the past', count: '1,200+ Books' },
    { id: 4, title: 'Arts', image: 'https://images.unsplash.com/photo-1513001900722-370f803f498d?w=400&h=500&fit=crop', description: 'Experience creativity', count: '900+ Books' },
  ];

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % 4);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + 4) % 4);

  return (
    <div className="modern-page">
      <nav className="top-nav">
        <div className="nav-logo" onClick={() => handleNavClick('home')}>
          <img src="/pageLogo.jpg" alt="Logo" />
          <span>Life-course Learning</span>
        </div>

        {/* DESKTOP MENU */}
        <div className="nav-menu desktop">
          <a href="#home" className={activeNav === 'home' ? 'active' : ''} onClick={(e) => { e.preventDefault(); handleNavClick('home'); }}>HOME</a>
          <a href="#library" className={activeNav === 'books' ? 'active' : ''} onClick={(e) => { e.preventDefault(); handleNavClick('books'); }}>LIBRARY</a>
          <a href="#explore" className={activeNav === 'explore' ? 'active' : ''} onClick={(e) => { e.preventDefault(); handleNavClick('explore'); }}>EXPLORE</a>
          <a href="#about" className={activeNav === 'about' ? 'active' : ''} onClick={(e) => { e.preventDefault(); handleNavClick('about'); }}>ABOUT US</a>
          <a href="#contact" className={activeNav === 'contact' ? 'active' : ''} onClick={(e) => { e.preventDefault(); handleNavClick('contact'); }}>CONTACT</a>
        </div>

        {/* MOBILE MENU BUTTON */}
        <button className="hamburger" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          {mobileMenuOpen ? '✕' : '☰'}
        </button>
      </nav>

      {/* MOBILE MENU DROPDOWN */}
      {mobileMenuOpen && (
        <div className="mobile-menu-dropdown">
          <a href="#home" className={activeNav === 'home' ? 'active' : ''} onClick={(e) => { e.preventDefault(); handleNavClick('home'); }}>HOME</a>
          <a href="#library" className={activeNav === 'books' ? 'active' : ''} onClick={(e) => { e.preventDefault(); handleNavClick('books'); }}>LIBRARY</a>
          <a href="#explore" className={activeNav === 'explore' ? 'active' : ''} onClick={(e) => { e.preventDefault(); handleNavClick('explore'); }}>EXPLORE</a>
          <a href="#about" className={activeNav === 'about' ? 'active' : ''} onClick={(e) => { e.preventDefault(); handleNavClick('about'); }}>ABOUT US</a>
          <a href="#contact" className={activeNav === 'contact' ? 'active' : ''} onClick={(e) => { e.preventDefault(); handleNavClick('contact'); }}>CONTACT</a>
        </div>
      )}

      {showLibrary ? (
        <BookLibrary />
      ) : showExplore ? (
        <ExplorePage />
      ) : (
        <>
          <div className="hero-section" id="home">
            <div className="hero-content">
              <p className="hero-subtitle">Welcome Back!</p>
              <h1 className="hero-title">EXPLORE THE<br />WORLD OF BOOKS.<br />GROW EVERY DAY.</h1>
              <p className="hero-description">
                Discover thousands of titles, build your knowledge,<br />
                and connect with our passionate reading community.
              </p>
              <div className="hero-stats">
                <div className="stat-item">
                  <div className="stat-number">10,000+</div>
                  <div className="stat-label">Books Available</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">5,000+</div>
                  <div className="stat-label">Active Members</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">50+</div>
                  <div className="stat-label">Categories</div>
                </div>
              </div>
            </div>
            <div className="card-grid">
              {cards.map((card, index) => (
                <div 
                  key={card.id} 
                  className="book-card" 
                  style={{ animationDelay: `${index * 0.1}s` }} 
                  onClick={() => alert(`Explore ${card.title} category`)}
                >
                  <div className="card-image" style={{ backgroundImage: `url(${card.image})` }}>
                    <div className="card-overlay">
                      <h3 className="card-title">{card.title}</h3>
                      <p className="card-desc">{card.description}</p>
                      <p className="card-count">{card.count}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="slider-controls">
              <button className="slider-btn" onClick={prevSlide}>‹</button>
              <button className="slider-btn" onClick={nextSlide}>›</button>
              <div className="slider-progress">
                <div className="progress-bar" style={{ width: `${((currentSlide + 1) / 4) * 100}%` }}></div>
              </div>
              <span className="slider-number">{`0${currentSlide + 1}`}</span>
            </div>
          </div>

          {showContactModal && (
            <div className="modal-overlay" onClick={() => setShowContactModal(false)}>
              <div className="contact-modal" onClick={e => e.stopPropagation()}>
                <button className="modal-close" onClick={() => setShowContactModal(false)}>×</button>
                <h2>Contact Us</h2>
                <p className="modal-subtitle">We'd love to hear from you!</p>
                {formStatus === 'success' ? (
                  <div className="success-message">
                    <div className="success-icon">✓</div>
                    <p>Message sent successfully!</p>
                  </div>
                ) : (
                  <form onSubmit={handleContactSubmit} className="contact-form">
                    <div className="form-row">
                      <input type="text" name="name" placeholder="Your Name" value={contactForm.name} onChange={handleContactChange} required />
                    </div>
                    <div className="form-row">
                      <input type="email" name="email" placeholder="Your Email" value={contactForm.email} onChange={handleContactChange} required />
                    </div>
                    <div className="form-row">
                      <input type="text" name="subject" placeholder="Subject" value={contactForm.subject} onChange={handleContactChange} required />
                    </div>
                    <div className="form-row">
                      <textarea name="message" placeholder="Your Message" rows="5" value={contactForm.message} onChange={handleContactChange} required></textarea>
                    </div>
                    <button type="submit" className="submit-btn" disabled={formStatus === 'sending'}>
                      {formStatus === 'sending' ? 'Sending...' : 'Send Message'}
                    </button>
                  </form>
                )}
              </div>
            </div>
          )}

          <footer className="professional-footer">
            <div className="footer-content">
              <div className="footer-section">
                <h3>Life-course Learning</h3>
                <p>Your journey to knowledge starts here. Discover, learn, and grow with our extensive collection of books and resources.</p>
                <div className="social-links">
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  </a>
                  <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Twitter">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                    </svg>
                  </a>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
                    </svg>
                  </a>
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                  </a>
                </div>
              </div>
              
              <div className="footer-section">
                <h4>Quick Links</h4>
                <ul>
                  <li><a href="#home" onClick={(e) => { e.preventDefault(); handleNavClick('home'); }}>Home</a></li>
                  <li><a href="#library" onClick={(e) => { e.preventDefault(); handleNavClick('books'); }}>Library</a></li>
                  <li><a href="#explore" onClick={(e) => { e.preventDefault(); handleNavClick('explore'); }}>Explore</a></li>
                  <li><a href="#about" onClick={(e) => { e.preventDefault(); handleNavClick('about'); }}>About Us</a></li>
                </ul>
              </div>
              
              <div className="footer-section">
                <h4>Resources</h4>
                <ul>
                  <li><a href="#blog" onClick={(e) => { e.preventDefault(); alert('Blog coming soon!'); }}>Blog</a></li>
                  <li><a href="#faq" onClick={(e) => { e.preventDefault(); alert('FAQ coming soon!'); }}>FAQ</a></li>
                  <li><a href="#support" onClick={(e) => { e.preventDefault(); alert('Support coming soon!'); }}>Support</a></li>
                  <li><a href="#privacy" onClick={(e) => { e.preventDefault(); alert('Privacy Policy coming soon!'); }}>Privacy Policy</a></li>
                </ul>
              </div>
              
              <div className="footer-section">
                <h4>Contact Us</h4>
                <ul className="contact-info">
                  <li>
                    <a href="tel:+254712345678" className="footer-contact-link">
                      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                      </svg>
                      +254 712 345 678
                    </a>
                  </li>
                  <li>
                    <a href="mailto:info@lifecourselearning.com" className="footer-contact-link">
                      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                      </svg>
                      info@lifecourselearning.com
                    </a>
                  </li>
                  <li>
                    <a href="https://wa.me/254712345678" target="_blank" rel="noopener noreferrer" className="footer-contact-link whatsapp-link">
                      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                      </svg>
                      WhatsApp Us
                    </a>
                  </li>
                  <li className="footer-address">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                    </svg>
                    <span>Nairobi, Kenya</span>
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="footer-bottom">
              <p>&copy; {new Date().getFullYear()} Life-course Learning. All rights reserved.</p>
              <p>Empowering minds through knowledge</p>
            </div>
          </footer>
        </>
      )}
    </div>
  );
}

export default HomePage;